import React, { Component } from 'react';
import { Table, Container, Row, Button, Alert, Col } from 'react-bootstrap';
//import { saveAs } from 'file-saver';
// ;
import config from '../../../config';
import funciones from '../../../middleware/funciones';
import TitleModule from '../../widgets/module_title';

export class generadorPlano extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            documentos: [],
            documentSelected: [],
            empresa: currentCompany,
            tipo: currentUserType,
            searchTipo: "",
            searchNombreCliente: "",
            searchNumero: "",
            searchCliente: "",
            searchVendedor: "",
            isAllChecked: false,
            type: "",
            message: "",
            show: false
        };
    }
    componentDidMount() {
        this.updateInfo();
    };

    buscar = ({ target }) => {
        const { name, value } = target;
        this.setState({ [name]: value });
    };

    addOrder = ({ target }) => {
        const { name } = target;
        const { checked } = target;
        let tmpDocumentSelected = [];
        let isChecked = false;
        if (name === "all") {
            if (checked) {
                this.checkallMasive(true)
                const { documentos } = this.state;
                documentos.forEach(element => {
                    tmpDocumentSelected.push(element.ID_PEDIDOS);
                });
                isChecked = true;
            } else {
                this.checkallMasive(false);
                tmpDocumentSelected = [];
            }
        } else {
            tmpDocumentSelected = this.state.documentSelected;
            const confirm = tmpDocumentSelected.findIndex(function (element) {
                return element === parseInt(name, 10);
            });
            if (checked) {
                if (confirm < 0) tmpDocumentSelected.push(name);
            } else {
                if (confirm >= 0) tmpDocumentSelected.splice(confirm, 1);
            }

        }
        this.setState({ documentSelected: tmpDocumentSelected, isAllChecked: isChecked })
    }

    updateInfo = () => {
        this.checkallMasive(false);
        const { empresa } = this.state
        const { tipo } = this.state

        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
                'tipo': tipo
            }
        }
        fetch(config.servBackEnd + '/invoice/listorders', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const datos = data.data;
                    const pedido = datos[0];
                    this.setState({
                        documentos: pedido,
                        documentSelected: []
                    });
                }
            })
            .catch((error) => console.error(error))
    }

    checkallMasive = (state) => {
        const { documentos } = this.state;
        documentos.forEach(element => {
            const ccheckbox = document.getElementById(element.ID_PEDIDOS)
            ccheckbox.checked = state;
        });
    }

    generarPlano = () => {
        //const now = Date.now().toString();
        //const pname = now.substring(now.length - 5, now.length);
        //const name = "001" + pname + ".PE0";

        const { empresa } = this.state
        const { tipo } = this.state
        const { documentSelected } = this.state

        const datasend = {
            method: 'POST',
            body: JSON.stringify(documentSelected),
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
                'tipo': tipo
            }
        }
        fetch(config.servBackEnd + '/invoice/generateplain', datasend)
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                if (data.ok) {
                    this.setState({
                        type: 'success',
                        message: `Archivo ${data.name} creado exitosamente en TRM`,
                        show: true
                    })
                    this.updateInfo();
                } else {
                    this.setState({
                        type: 'danger',
                        message: data.message,
                        show: true
                    })
                }
                // const blob = await response;
                // const nameback = await response;
                // this.checkallMasive(false);
                // console.log(blob);
                // console.log(nameback);
                // if (blob) {
                //     this.updateInfo();
                //     const file = new Blob([blob], { type: 'text/plain;charset=utf-8' });
                //     saveAs(file, name);
                // } else {
                //     //console.log("Archivo Inexistente");
                // }
            })
            .catch((err) => {
                console.error(err);
            })

    }

    render() {
        const facturas = this.state.documentos;
        const { searchTipo } = this.state;
        const { searchNombreCliente } = this.state;
        const { searchNumero } = this.state;
        const { searchCliente } = this.state;
        const { searchVendedor } = this.state;
        const { documentSelected } = this.state;
        const { isAllChecked } = this.state;
        const { type } = this.state;
        const { message } = this.state;
        const { show } = this.state;

        const addOrder = this.addOrder;
        return (
            <div className="contenedor">
                <TitleModule text={'Generador de plano CGUNO'} />
                <div>
                    {show && <Alert variant={type} >{message}</Alert>}
                    <Container fluid>
                        <Row>
                            <Col>
                                {documentSelected.length !== 0 && <Button className="m-3" onClick={this.generarPlano}>Descargar Plano</Button>}
                                {documentSelected.length === 0 && <Alert variant="danger"> Seleccione al menos un pedido para generar el plano</Alert>}
                            </Col>
                            <Col>
                                <Button className="m-3" onClick={this.updateInfo}>Actualizar Informacion</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Table hover bordered responsive size="sm" className="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th><input type="text" maxLength="2" size="3" name="searchTipo" onChange={this.buscar} /></th>
                                        <th><input type="text" maxLength="4" size="5" name="searchNumero" onChange={this.buscar} /></th>
                                        <th><input type="text" maxLength="10" size="11" name="searchCliente" onChange={this.buscar} /></th>
                                        <th><input type="text" maxLength="10" size="11" name="searchNombreCliente" onChange={this.buscar} /></th>
                                        <th><input type="text" maxLength="10" size="11" name="searchVendedor" onChange={this.buscar} /></th>
                                    </tr>
                                    <tr>
                                        <th><input type="checkbox" name="all" onChange={addOrder} checked={isAllChecked} /></th>
                                        <th>Fecha Documento</th>
                                        <th>Tipo Documento</th>
                                        <th>Numero Documento</th>
                                        <th>Codigo Cliente</th>
                                        <th>Nombre Cliente</th>
                                        <th>Vendedor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {facturas.map(function (currentData, index) {
                                        if (currentData.TIPO_DOCUMENTO_CABECERA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                                            && currentData.NOMBRE_CLIENTE.toLowerCase().search(searchNombreCliente.toLowerCase()) > -1
                                            && currentData.NUMERO_FACTURA_CABECERA.toLowerCase().search(searchNumero.toLowerCase()) > -1
                                            && currentData.DOCUMENTO_CLIENTE.toLowerCase().search(searchCliente.toLowerCase()) > -1
                                            && currentData.VENDEDOR.toLowerCase().search(searchVendedor.toLowerCase()) > -1
                                        ) {
                                            return <tr key={index}>
                                                <td><input id={currentData.ID_PEDIDOS} name={currentData.ID_PEDIDOS} type="checkbox" onChange={addOrder} /></td>
                                                <td name="tipo">{funciones.formatDate(currentData.FECHA_DOCUMENTO)}</td>
                                                <td name="tipo">{currentData.TIPO_DOCUMENTO_CABECERA}</td>
                                                <td name="dian">{currentData.NUMERO_FACTURA_CABECERA}</td>
                                                <td name="numero">{currentData.DOCUMENTO_CLIENTE}</td>
                                                <td name="cliente">{currentData.NOMBRE_CLIENTE}</td>
                                                <td name="cliente">{currentData.VENDEDOR}</td>
                                                <td name="id" className="d-none">{currentData.ID_PEDIDOS}</td>
                                            </tr>;
                                        } else {
                                            return <tr key={index + "f0"}></tr>
                                        }
                                    })}
                                </tbody>
                            </Table>
                        </Row>
                    </Container>
                </div>

            </div>
        )
    }
}

export default generadorPlano



// WEBPACK FOOTER //
// ./src/components/bussines/pedidos/generadorPlano.jsx